//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  title: 'emplayeeInfo',
  data: function data() {
    return {
      tableData: []
    };
  }
};